import React, { memo, useMemo, useState } from "react";
import { Box, InputAdornment,TextField, Typography } from "@mui/material";

interface PriceInputProps {
  label: string;
  value: number;
  onInputPriceChange: (newPrice: any) => void;
  validationFn?: (value: number) => boolean;
  sx?: any;
}

const PriceInput = memo(({
  value,
  label,
  onInputPriceChange,
  validationFn,
  sx,
}: PriceInputProps) => {
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const handleChangeValue = (e: any) => {
    const incomingValue = e.target.value;
    const cursorPosition = e.target.selectionStart;
    const normalizedString = incomingValue.replace(/^0+|[^0-9]/gi, "");
    const newCursorPosition = Math.max(0, cursorPosition - (incomingValue.length - normalizedString.length));

    setIsDirty(normalizedString.length > 0)
    onInputPriceChange(normalizedString);

    setTimeout(() => {
      e.target.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
  };

  const isValid = useMemo(() => {
    return validationFn && isDirty ? validationFn(value) : true;
  }, [validationFn, value, isDirty]);

  const labelValidationStyle = useMemo(() => {
    let style = {
      backgroundColor: "#F3F3F3",
      color: "#1F1F1F",
    };

    if (isDirty && !isValid) {
      style = {
        backgroundColor: "#FFF6F9",
        color: "#BF295C",
      };
    } else if (!isValid) {
      style = {
        backgroundColor: "#FFE4E6",
        color: "#D62F39",
      };
    }

    return style;
  }, [isValid, isDirty]);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #D6D6DB",
        flex: 1,
        ...sx,
      }}
    >
      <Box
        sx={{
          padding: "16px",
          minWidth: 192,
          borderTopLeftRadius: sx?.borderTopLeftRadius,
          borderTopRightRadius: sx?.borderTopRightRadius,
          borderBottomLeftRadius: sx?.borderBottomLeftRadius,
          borderBottomRightRadius: sx?.borderBottomRightRadius,
          ...labelValidationStyle,
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
            textTransform: "capitalize",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: 170,
        }}
      >
        <TextField
          placeholder="0.00"
          onChange={handleChangeValue}
          value={value > 0 ? value : ""}
          sx={{
            color: "#828282",
            fontSize: "16px",
            "&::placeholder": {
              color: "#828282",
            },
            "& fieldset": { border: "none" },
          }}
          InputProps={{
            inputMode: "numeric",
            startAdornment: <InputAdornment position="start">€</InputAdornment>,
          }}
        />
      </Box>
    </Box>
  );
});

export {PriceInput}
